"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCookie = exports.setCookie = exports.getCookie = exports.getCookies = void 0;
function getCookieKeyValues() {
    return decodeURIComponent(document.cookie)
        .split(';')
        .map(val => {
        let value = val.trim();
        let index = value.indexOf('=');
        if (index >= 0) {
            return {
                key: value.substring(0, index),
                value: value.substring(index + 1)
            };
        }
        return {
            key: val,
            value: ''
        };
    });
}
function getCookies() {
    const res = {};
    getCookieKeyValues().forEach(kv => {
        res[kv.key] = kv.value;
    });
    return res;
}
exports.getCookies = getCookies;
function getCookie(name) {
    return getCookieKeyValues().find(kv => kv.key === name)?.value ?? '';
}
exports.getCookie = getCookie;
function setCookie(name, value, path = '/', expires) {
    let val = `${name}=${value}`;
    if (expires) {
        val += '; expires=' + expires.toUTCString();
    }
    if (path) {
        val += '; path=' + path;
    }
    document.cookie = val;
}
exports.setCookie = setCookie;
function removeCookie(name, path = '/') {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
}
exports.removeCookie = removeCookie;
//# sourceMappingURL=cookie.js.map